module.exports = __webpack_public_path__ + "img/ICP.d0289dc0.png";